export default "__VITE_ASSET__BfnDTTmD__"